import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = verificando | false = não autenticado | objeto = admin autenticado
  const [user, setUser] = useState(null);

  useEffect(() => {
    // evita 401 no console para visitantes: só consulta a sessão se já houve login neste navegador
    if (!localStorage.getItem("hg_admin_session")) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("hg_admin_session");
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("hg_admin_session", "1");
      setUser(data);
      return { ok: true };
    } catch (err) {
      return { ok: false, error: formatApiError(err, "Falha no login") };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      localStorage.removeItem("hg_admin_session");
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
